import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-pink-50/30 to-white">
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 bg-white/80 overflow-y-auto h-screen ml-0 sm:ml-64 transition-all duration-300 ease-in-out">
          <div className="sticky top-0 z-10 bg-white/90 backdrop-blur-sm border-b border-pink-100">
            <Navbar />
          </div>
          <div className="container mx-auto px-2 sm:px-4 py-0 sm:py-2 max-w-7xl">
            {/* Table styles wrapper */}
            <div className="[&_table]:w-full [&_table]:border-collapse [&_table]:mb-4
                          [&_th]:text-left [&_th]:bg-gray-50 [&_th]:p-2 sm:p-3 [&_th]:border-b [&_th]:border-gray-200
                          [&_td]:p-2 sm:p-3 [&_td]:border-b [&_td]:border-gray-100
                          [&_tr:hover]:bg-pink-50/50 [&_tr]:transition-colors
                          [&_thead_tr]:bg-gradient-to-r [&_thead_tr]:from-gray-50 [&_thead_tr]:to-pink-50/30">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div> 
  );
};

export default Layout; 